import { Dropdown } from "@similarweb/ui-components";
import { translate } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import type { ReactElement } from "react";
import { cloneElement, type JSX } from "react";
import type { AssignableUser } from "../../types/common";
import { StyledDDContainer, StyledDropdownItem, StyledHeader, StyledHeaderText } from "./styles";

type Props = {
    button: ReactElement;
    numberOfLeads: number;
    users: readonly AssignableUser[];
    onSelect(user: Readonly<AssignableUser>): void;
    disabled?: boolean;
};

const UsersDropdown = (props: Props) => {
    const { button, numberOfLeads, users, onSelect, disabled = false } = props;

    function handleItemClick(item: { user: AssignableUser; children: string }) {
        if (item.user.leadsQuota >= numberOfLeads) {
            onSelect(item.user);
        }
    }

    function handleSearch(term: string, item: JSX.Element) {
        return (item.props as { user: AssignableUser }).user.name.toLowerCase().includes(term.toLowerCase());
    }

    return (
        <StyledDDContainer id="users-dropdown">
            <Dropdown
                hasSearch
                appendTo="#users-dropdown"
                dropdownPopupPlacement="ontop-left"
                headerComponent={
                    <StyledHeader justifyContent="space-between">
                        <I18n
                            element={StyledHeaderText}
                            data-automation="name-column-text"
                            translatable={{
                                key: "si.multi_selector.assign.autocomplete.header.name",
                            }}
                        />
                        <I18n
                            element={StyledHeaderText}
                            data-automation="quota-column-text"
                            translatable={{
                                key: "si.multi_selector.assign.autocomplete.header.quota",
                            }}
                        />
                    </StyledHeader>
                }
                searchFilter={handleSearch}
                searchPlaceHolder={translate("si.multi_selector.assign.autocomplete.placeholder")}
                width={300}
                onClick={handleItemClick}
                disabled={disabled}
            >
                {/* @ts-expect-error error TS2698: Spread types may only be created from object types. */}
                {[cloneElement(button, { ...button.props, key: "users-dd-button" })].concat(
                    users.map((user) => {
                        return (
                            <StyledDropdownItem
                                key={user.id}
                                disabled={user.leadsQuota < numberOfLeads}
                                // @ts-expect-error - user is not defined on the type
                                user={user}
                            >
                                <span>{user.name}</span>
                                <span>{user.leadsQuota}</span>
                            </StyledDropdownItem>
                        );
                    }),
                )}
            </Dropdown>
        </StyledDDContainer>
    );
}

export default UsersDropdown;
